import { EXPERIMENTS, type IExperiments } from '@lifk/types'

const defaults = Object.fromEntries(
  Object.entries(EXPERIMENTS).map(([k, v]) => [k, v[0]])
) as Partial<IExperiments>

export function getExperiments(): Partial<IExperiments> {
  const raw = document.cookie.match(/experiments=([^;]+)/)?.[1]
  if (!raw) return defaults
  try {
    return JSON.parse(decodeURIComponent(raw)) as Partial<IExperiments>
  } catch {
    return defaults
  }
}
